// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"63eceacc","455":"07d9746d","977":"0183dfe3"}[chunkId] + ".chunk.js";
};